import React from 'react';

/**
 * @deprecated Please use `isExoticComponent` from `@panwds/react-utils`
 */
function isExoticComponent(component) {
    return (typeof component === 'object' &&
        typeof component.$$typeof === 'symbol' &&
        ['react.memo', 'react.forward_ref'].includes(component.$$typeof.description));
}
/**
 * @deprecated Please use `isClassComponent` from `@panwds/react-utils`
 */
function isClassComponent(component) {
    return (typeof component === 'function' &&
        (() => {
            const proto = Object.getPrototypeOf(component);
            return !!proto.prototype && !!proto.prototype.isReactComponent;
        })());
}
/**
 * @deprecated Please use `isReactComponent` from `@panwds/react-utils`
 */
function isReactComponent(component) {
    return isClassComponent(component) || typeof component === 'function' || isExoticComponent(component);
}
function flexRender(target, props = {}) {
    if (isReactComponent(target)) {
        const Comp = target;
        return React.createElement(Comp, { ...props });
    }
    return target;
}

export { flexRender, isClassComponent, isExoticComponent, isReactComponent };
//# sourceMappingURL=component.esm.js.map
